import { array, boolean, mixed, object, string } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

const answerChoicesFormats = ['choices_one', 'choices_many', 'select']
const multipleChoicesFormats = ['choices_one', 'choices_many']
export const hasAnswerChoices = (format) => answerChoicesFormats.includes(format)
export const allowsOtherChoices = (format) => multipleChoicesFormats.includes(format)

const normalizeChoiceValue = (choice) => choice?.trim().toLowerCase() ?? ''

const uniqueAnswerChoiceSchema = object({
  id: string().nullable(),
  choice: string().trim().required(),
}).test('unique-choice', function uniqueChoice(value) {
  if (!value || !normalizeChoiceValue(value.choice)) return true

  const choices = this.parent
  if (!Array.isArray(choices)) return true

  const indexMatch = this.path.match(/\[(\d+)\]$/)
  const currentIndex = indexMatch ? Number(indexMatch[1]) : -1
  if (currentIndex < 0) return true

  const normalized = normalizeChoiceValue(value.choice)
  const isDuplicate = choices.some((option, index) => (
    index < currentIndex && normalizeChoiceValue(option?.choice) === normalized
  ))

  if (isDuplicate) {
    return this.createError({
      path: `${this.path}.choice`,
      message: I18n.t('publisher.event_type_editor_crud.booking_page.duplicate_choice'),
    })
  }

  return true
})

export const getValidationSchema = () => object({
  inviteeQuestions: array().of(object({
    _destroy: boolean(),
    name: string().when('_destroy', {
      is: true,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.trim().required()
    }),
    answerChoices: mixed()
      .when('format', {
        is: (format) => hasAnswerChoices(format),
        then: array().of(uniqueAnswerChoiceSchema).required(),
        otherwise: (schema) => schema.notRequired()
      }),
  }))
})
